const EDIT_SHIPPING_FEE_DRAFT_PREFIX = 'admin:shippingFeeDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeShippingPriceValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// 배송비 상세는 다시 입력해야 하는 금액 값만 sessionStorage에 남긴다.
export const createShippingFeeDraftPayload = ({ values = {} }) => {
    return {
        values: {
            shippingPrice: normalizeShippingPriceValue(values.shippingPrice),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 편집 흐름을 이어간다.
export const applyShippingFeeDraft = ({ baseValues = {}, draft }) => {
    if (!draft) {
        return {
            values: {
                ...baseValues,
                shippingPrice: normalizeShippingPriceValue(baseValues.shippingPrice),
            },
        }
    }

    const draftValues = draft.values || {}

    return {
        values: {
            ...baseValues,
            shippingPrice: draftValues.shippingPrice === undefined
                ? normalizeShippingPriceValue(baseValues.shippingPrice)
                : normalizeShippingPriceValue(draftValues.shippingPrice),
        }
    }
}

export const createEditShippingFeeDraftKey = (adminId) => `${EDIT_SHIPPING_FEE_DRAFT_PREFIX}${adminId}`

export const readShippingFeeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveShippingFeeDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearShippingFeeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
